const LOGO =
  "https://customer-assets.emergentagent.com/job_explore-journeys-26/artifacts/4jx8ieos_PHOTO-2026-06-24-12-59-57.jpeg";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1B0F3A] text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="absolute -top-24 right-1/4 w-96 h-96 rounded-full bg-[#F97316]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={LOGO}
                alt="Celesta"
                className="h-14 w-14 object-contain bg-white p-1"
              />
              <div>
                <div className="font-serif text-3xl tracking-[0.2em] text-white">
                  CELESTA
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.24em] text-[#FFB47A] font-semibold">
                  Book anything · Travel everywhere
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-white/70 leading-relaxed">
              A full-service travel bureau headquartered in Chennai. One platform
              for flights, cabs, buses, hotels, trains, holidays and events.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FFB47A] mb-4 font-semibold">
              Services
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="#services" className="hover:text-[#F97316] transition-colors">Flights</a></li>
              <li><a href="#services" className="hover:text-[#F97316] transition-colors">Hotels</a></li>
              <li><a href="#services" className="hover:text-[#F97316] transition-colors">Holidays</a></li>
              <li><a href="#services" className="hover:text-[#F97316] transition-colors">Events</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FFB47A] mb-4 font-semibold">
              Company
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="#about" className="hover:text-[#F97316] transition-colors">About</a></li>
              <li><a href="#why" className="hover:text-[#F97316] transition-colors">Why Celesta</a></li>
              <li><a href="#packages" className="hover:text-[#F97316] transition-colors">Corporate</a></li>
              <li><a href="#contact" className="hover:text-[#F97316] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FFB47A] mb-4 font-semibold">
              Contact
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>No 17, St Thomas Street,<br />Mudichur, Chennai 600048</li>
              <li><a href="tel:+917338745559" className="hover:text-[#F97316] transition-colors">+91 73387 45559</a></li>
              <li><a href="mailto:bookings@celestaflights.com" className="hover:text-[#F97316] transition-colors">bookings@celestaflights.com</a></li>
              <li><a href="https://www.celestaflights.com" className="hover:text-[#F97316] transition-colors">www.celestaflights.com</a></li>
            </ul>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="border-t border-white/10 py-10 overflow-hidden">
          <div className="font-serif text-[16vw] leading-none tracking-[0.05em] text-white/5 select-none whitespace-nowrap">
            CELESTA
          </div>
        </div>

        <div className="pt-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs uppercase tracking-[0.22em] text-white/50">
            © {new Date().getFullYear()} Celesta Flights · All rights reserved
          </div>
          <div className="flex items-center gap-8 text-xs uppercase tracking-[0.22em] text-white/50">
            <a href="#" className="hover:text-[#F97316] transition-colors">Privacy</a>
            <a href="#" className="hover:text-[#F97316] transition-colors">Terms</a>
            <a href="#" className="hover:text-[#F97316] transition-colors">Refund</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
